import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";
import CKEditorInput from "../../../utils/forms/CKEditorInput";

// Components
import Loader from "../../utils/Loader";
import ErrorText from "../../utils/error-success/ErrorText";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";

// Utils
import { editorChange } from "../../../utils/forms/inputHandling";

class Page extends Component {
	constructor(props) {
		super(props);

		this.state = {
			id: this.props.match.params.id,
			isLoading: true,
			data: null,
			error: "",
			updateLoading: false,
			updateSuccess: "",
			updateErrors: {}
		};

		this.CKEditorInput = new CKEditorInput();
	}

	componentDidMount() {
		this.loadData();
	}

	loadData = () => {
		const { id } = this.state;

		const apiEndpoint = "pages/" + id;

		const params = { language: process.env.REACT_APP_LANGUAGE };

		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY };
		return axios
			.get(process.env.REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER, params })
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({ isLoading: false, error: response.data.message });
				} else {
					this.setState({ isLoading: false, data: { ...response.data } });
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						isLoading: false,
						error: err.response.data.errors
							? err.response.data.errors
							: err.response.data.message
					});
				} else {
					this.setState({ isLoading: false, error: err.message });
				}
			});
	};

	handleSubmit = () => {
		const { data } = this.state;
		const { user } = this.props;

		// Add language to data
		data.language = process.env.REACT_APP_LANGUAGE;

		// Set loading states, reset error/success
		this.setState({
			updateSuccess: "",
			updateErrors: {},
			updateLoading: true
		});

		// Set editor to readonly
		this.CKEditorInput.setCKReadonly(true);

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(process.env.REACT_APP_API_URL + "pages/" + data.permalink, data, {
				headers: AUTH_HEADER
			})
			.then(response => {
				this.CKEditorInput.setCKReadonly(false);

				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				this.CKEditorInput.setCKReadonly(false);

				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	};

	render() {
		return (
			<React.Fragment>
				{this.state.error ? (
					<ErrorText errors={this.state.error} />
				) : this.state.isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<React.Fragment>
						{!isEmpty(this.state.data) ? (
							<React.Fragment>
								{this.state.updateSuccess && (
									<SuccessWrap animate={1}>
										{this.state.updateSuccess}
									</SuccessWrap>
								)}
								<div className="form-field page-title-display">
									<label>Page Title:</label>
									{this.state.data.title}
								</div>

								{/* CKEditor */}
								<CKEditor
									scriptUrl="/ckeditor/ckeditor.js"
									content={this.state.data.content}
									config={{
										toolbar: "BasicWithTools",
										filebrowserImageBrowseUrl: "/image-browser",
										filebrowserBrowseUrl: "/file-browser",
										uploadUrl: process.env.REACT_APP_API_URL + `files`
									}}
									events={{
										instanceReady: editorReady.bind(this),
										change: e =>
											editorChange("content", e, this.state).then(res =>
												this.setState(res)
											)
									}}
									ref={instance => {
										this.CKEditorInput.addEditor("content", instance);
									}}
								/>

								<div className="btn_container">
									{this.state.updateErrors.general && (
										<ErrorWrap animate={1}>
											{this.state.updateErrors.general}
										</ErrorWrap>
									)}
									<button
										className={
											"btn submit-btn" +
											(this.state.updateLoading ? " loading" : "")
										}
										name="submit"
										onClick={() => this.handleSubmit()}
										disabled={this.state.updateLoading}
									>
										<span>Submit</span>
									</button>
								</div>
							</React.Fragment>
						) : (
							<div>Unable to find the page you were looking for.</div>
						)}
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ userTokenUpdate, userLogout }
)(Page);



// WEBPACK FOOTER //
// ./src/components/admin/pages/Page.js